module.exports = __webpack_public_path__ + "static/media/add_multiple_agents_active.d3286d90.svg";